import { render, staticRenderFns } from "./recyclingBinLog.vue?vue&type=template&id=416d0821"
import script from "./recyclingBinLog.vue?vue&type=script&lang=js"
export * from "./recyclingBinLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports